/**
 * This function checks if the user is using an iPhone with Safari browser.
 * @returns {boolean} - True if Iphone and Safari.
 */
const isIphoneSafari = () => {
    const { userAgent } = window.navigator;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isIOS && isSafari;
};

export default isIphoneSafari;